import React from 'react';
import $ from 'jquery';

import {GetParams, MWBaseURL} from './../Utilities.js'
import {createApiClient} from "../api/ApiClient";

class AcctFilter extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			firm: null,
			acct: null,

			needToUpdate: false,
			updateCount: 0,
      isDropdownOpen: false
		};
    this.selectRef = React.createRef();
	}

	static getDerivedStateFromProps(props, state) {
		let obj = {}
		if(state.date !== props.date || state.group !== props.group || state.firm !== props.firm || state.acct !== props.acct){
			obj = {...props, needToUpdate: true}
		}
		if(state.updateCount !== props.updateCount){
			obj.updateCount = props.updateCount
			obj.needToUpdate = true
		}
		return obj;
	}

	componentDidUpdate(props, state){
		let self = this
		if(this.state.needToUpdate && !this.state.isDropdownOpen){
			this.setState({needToUpdate: false}, function(){
				self.load()
			})
		}
	}

	componentDidMount() {
		this.load()
    $(this.selectRef.current).on('show.bs.select', () => {
      this.setState({ isDropdownOpen: true });
    });

    $(this.selectRef.current).on('hide.bs.select', () => {
      this.setState({ isDropdownOpen: false });
    });
	}

	setFilterValue = (e) => {
		let self = this
		let name = Array.from(e.target.selectedOptions, option => option.innerText);
		let val = Array.from(e.target.selectedOptions, option => option.value);
		self.setState({acct: val}, function(){
			let obj = {
				selectedAcct: val
			}
			if(val.length === 1){
				obj.selectedAcctName = name[0].split(": ")[1]
			}
			self.state.refilter(obj)
		})
		
	}
  
	clearFilter = () => {
		this.state.refilter({
			selectedAcct: []
		})
	}

	load(){
		let self = this
		const apiClient = createApiClient();
		apiClient.get(MWBaseURL()+(self.state.view === 6 ? "account_list_agg?" : "account_list?")+GetParams(self.state))
		.then(data => {
			$("#accountFilter option").remove()
			let sorted = data.sort((a, b) => {
				if(self.state.acct.includes(a.account) && !self.state.acct.includes(b.account)){
					return -1
				}
				if(!self.state.acct.includes(a.account) && self.state.acct.includes(b.account)){
					return 1
				}
				return 0
			})

			sorted.forEach(function(item, index){
				if(!self.state.firm.length || self.state.firm.includes(item.class_name)){
					$("#accountFilter").append('<option value="'+item.account+'" data-tokens="'+item.group_name+'" "'+item.class_name+'">'+item.group_name+": "+item.account +(item.fname ? ": "+item.fname+" "+item.lname : "")+'</option>');
				}
			})
			$("#accountFilter").selectpicker('val', self.state.acct).selectpicker('refresh');

			let selVal = $("#accountFilter").selectpicker('val')
			if(selVal.length !== self.state.acct.length){
				self.setState({acct: selVal}, function(){
					self.state.refilter({
						selectedAcct: selVal
					})
				})
			}
		}).catch(e => console.log(e));
	}

	render(){
		return (
			<div className="col-lg-2 col-md-3 col-sm-4 pt-1 input-group">
				<select ref={this.selectRef} className="selectpicker form-control" id="accountFilter" onChange={this.setFilterValue} title="Filter Account"
          data-live-search="true" data-actions-box="true" data-size="10" multiple></select>
				<div className="input-group-append">
					<button className="btn btn-outline-secondary clear-btn" type="button" onClick={this.clearFilter}><img src="icon.png" alt="X"/></button>
				</div>
			</div>
		)
	}
}
export default AcctFilter;